/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MCQAttemptRequestAnswers } from './mCQAttemptRequestAnswers';

/**
 * Student's request to submit an MCQ attempt.
 */
export interface MCQAttemptRequest {
  answers: MCQAttemptRequestAnswers;
}
